import Alpine from 'alpinejs'
import Tooltip from "@ryangjchandler/alpine-tooltip";
import Clipboard from "@ryangjchandler/alpine-clipboard"
import Focus from '@alpinejs/focus'
import Mask from '@alpinejs/mask'
import 'tippy.js/dist/tippy.css';
import Persist from '@alpinejs/persist'
import sort from '@alpinejs/sort'

Alpine.plugin(Focus)
Alpine.plugin(Tooltip);
Alpine.plugin(Clipboard)
Alpine.plugin(Mask)
Alpine.plugin(Persist)
Alpine.plugin(sort)
window.Alpine = Alpine
Alpine.start()